import get from 'lodash/get'

export function setCartHeaders (token) {
  return {
    ...(token === false
      ? {}
      : { 'X-Cart-Token': token || get(vueSupport, 'cart.token', '') })
  }
}
